import React from "react";
import { Col, Container, Placeholder, Row } from "react-bootstrap";

export default function LoadingPlaceholder() {
  return (
    <>
      <Container className="mt-5">
        <Row>
          <Col md={4}>
            <Placeholder as="div" animation="glow">
              <Placeholder.Button xs={12} aria-hidden="true" />
            </Placeholder>
          </Col>
          <Col md={4}>
            <Placeholder as="div" animation="glow">
              <Placeholder.Button xs={12} aria-hidden="true" />
            </Placeholder>
          </Col>
          <Col md={4}>
            <Placeholder as="div" animation="glow">
              <Placeholder.Button xs={12} aria-hidden="true" />
            </Placeholder>
          </Col>
        </Row>
        <div className="mt-5"></div>
        <Row>
          <Col md={4}>
            <Placeholder as="div" animation="glow">
              <Placeholder md={12} />
            </Placeholder>
          </Col>
          <Col md={4}>
            <Placeholder as="div" animation="glow">
              <Placeholder md={12} />
            </Placeholder>
          </Col>
          <Col md={4}>
            <Placeholder as="div" animation="glow">
              <Placeholder md={12} />
            </Placeholder>
          </Col>
        </Row>

        <div className="mt-5"></div>
        <Row>
          <Col md={12}>
            <Placeholder as="div" animation="glow">
              <Placeholder md={12} />
            </Placeholder>
          </Col>
        </Row>
        <div className="mt-5"></div>
        <Row>
          <Col md={4}>
            <Placeholder as="div" animation="glow">
              <Placeholder md={12} />
            </Placeholder>
          </Col>
          <Col md={4}>
            <Placeholder as="div" animation="glow">
              <Placeholder md={12} />
            </Placeholder>
          </Col>
          <Col md={4}>
            <Placeholder as="div" animation="glow">
              <Placeholder md={12} />
            </Placeholder>
          </Col>
        </Row>
      </Container>
    </>
  );
}
